import gql from "graphql-tag";
import { MemoPhotoFragment } from "./fragments";

import { MemoPhoto } from "types";
import { createBoundMutation } from "./util";

const upsertPhoto = gql`
  mutation upsertMemoPhoto($id: String, $memo_id: String, $photo: String!) {
    upsertMemoPhoto(id: $id, memo_id: $memo_id, photo: $photo) {
      ...MemoPhotoFragment
    }
  }
  ${MemoPhotoFragment}
`;
const deletePhoto = gql`
  mutation deleteMemoPhoto($id: String!) {
    deleteMemoPhoto(id: $id)
  }
`;

export namespace photoMutations {
  export interface UpsertPhotoArgs {
    id?: string;
    memo_id: string;
    photo: string;
  }
  export interface UpsertPhotoData {
    upsertMemoPhoto: MemoPhoto;
  }

  export const UpsertPhoto = createBoundMutation<
    UpsertPhotoData,
    UpsertPhotoArgs
  >({
    mutation: upsertPhoto,
    cacheKey: "memoPhotos",
    isAdd: true
  });

  export interface DeletePhotoArgs {
    id: string;
  }
  export interface DeletePhotoData {
    deleteMemoPhoto: string;
  }

  export const DeletePhoto = createBoundMutation<
    DeletePhotoData,
    DeletePhotoArgs
  >({
    mutation: deletePhoto,
    cacheKey: "memoPhotos",
    isDelete: true
  });
}



// WEBPACK FOOTER //
// ./src/api/photo.ts